import { apiClient } from "../shared/utils/apiClient";
import logger from "../shared/utils/logger";

/**
 * Blog Service
 * Wraps the public blog endpoints. Both routes are first-party, server-rendered
 * content with pre-sanitised HTML in the post payload.
 *
 *   GET /api/blog        -> { posts: [...] }  (newest first)
 *   GET /api/blog/:slug  -> { post: {...} }   (404 if not found)
 */
class BlogService {
  constructor() {
    this.baseUrl = "/api/blog";
  }

  /**
   * List all published posts (newest first).
   * @returns {Promise<Array>} array of post summaries
   */
  async listPosts() {
    try {
      const response = await apiClient.get(this.baseUrl);
      return response.data?.posts || [];
    } catch (error) {
      logger.error("BlogService: failed to list posts", error);
      throw error;
    }
  }

  /**
   * Fetch a single post by slug.
   * @param {string} slug
   * @returns {Promise<Object|null>} the post, or null if not found (404)
   */
  async getPost(slug) {
    try {
      const response = await apiClient.get(
        `${this.baseUrl}/${encodeURIComponent(slug)}`,
      );
      return response.data?.post || null;
    } catch (error) {
      if (error?.status === 404) {
        return null;
      }
      logger.error("BlogService: failed to fetch post", error);
      throw error;
    }
  }
}

const blogService = new BlogService();
export default blogService;
